/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, April 2022
 * @flow
 */

import React, { useState, useCallback, useEffect } from 'react';
import CubbyContext from './CubbyContext';

const CubbyContextProvider = ({ children }) => {
  const [isPickedUpUndoEnabled, setIsPickedUpUndoEnabled] = useState(false);
  const [undoOrderInfo, setUndoOrderInformation] = useState({});

  const setUndoOrderInfo = useCallback((orderInfo) => {
    setUndoOrderInformation(orderInfo);
  }, []);

  useEffect(() => {
    if (undoOrderInfo && Object.keys(undoOrderInfo).length !== 0 && undoOrderInfo.constructor === Object) {
      setIsPickedUpUndoEnabled(true);
    } else {
      setIsPickedUpUndoEnabled(false);
    }
  }, [undoOrderInfo]);

  return (
    <CubbyContext.Provider value={{
      isPickedUpUndoEnabled: isPickedUpUndoEnabled,
      undoOrderInfo: undoOrderInfo,
      setUndoOrderInfo: setUndoOrderInfo,
    }}>
      {children}
    </CubbyContext.Provider>
  );
};

export default CubbyContextProvider;
